var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('a',{staticStyle:{"margin":"50px","display":"block"},on:{"click":_vm.facebookShare}},[_c('i',{staticClass:"fa fa-facebook",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('svg-icon',{staticStyle:{"width":"40px","height":"40px"},attrs:{"icon-class":"facebook-black"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c1270d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/share/index.vue
// module id = null
// module chunks = 